export const TaskPriorities = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
};

export const TaskPriorityColors = {
  RED: 'red',
  ORANGE: 'orange',
  YELLOW: '#F8DFA4',
};

export const TaskEntityTypes = {
  GOAL: 'goal',
  CLIENT: 'client',
  ORDER: 'order',
  LINE_ITEM: 'line_item',
  TASK: 'task',
  CYCLE: 'cycle',
  FUTURE_CYCLE: 'future_cycle',
  FLIGHT: 'flight',
};

export const TaskQuickFilters = {
  CLEAR: 'clear',
  MY_TASKS: 'my_tasks',
  OVERDUE: 'overdue',
  DUE_TODAY: 'due_today',
  DUE_THIS_WEEK: 'due_this_week',
  WORKFLOW_TASKS: 'workflow_tasks',
  UNASSIGNED_TASKS: 'unassigned_tasks',
};

export const TaskQuickFilterList = [
  { key: TaskQuickFilters.CLEAR, value: 'Clear', field: null },
  { key: TaskQuickFilters.MY_TASKS, value: 'My Tasks', field: 'assignee_id' },
  { key: TaskQuickFilters.OVERDUE, value: 'Overdue', field: 'over_due' },
  { key: TaskQuickFilters.DUE_TODAY, value: 'Due Today', field: 'due_date' },
  { key: TaskQuickFilters.DUE_THIS_WEEK, value: 'Due This Week', field: 'due_date' },
  { key: TaskQuickFilters.WORKFLOW_TASKS, value: 'Workflow Tasks', field: 'is_workflow_task' },
  { key: TaskQuickFilters.UNASSIGNED_TASKS, value: 'Unassigned Tasks', field: 'assignee_id' },
];

export const TaskGroupByOptions = [
  { key: null, value: i18n.$t('Clear') },
  { key: 'queue_id', value: i18n.$t('Queue') },
  { key: 'priority', value: i18n.$t('Priority') },
  { key: 'assignee_id', value: i18n.$t('Assignee') },
  { key: 'status_id', value: i18n.$t('Status') },
];

export const TASK_PAGE_SIZE = 50;

export const TaskRoutes = {
  TASKS: 'tasks',
};

export const DueDateFieldLabels = {
  start_date: 'Start Date',
  end_date: 'End Date',
};

export const TaskGroupByFields = {
  PRIORITY: 'priority',
  STATUS_ID: 'status_id',
  QUEUE_ID: 'queue_id',
  ASSIGNEE_ID: 'assignee_id',
};

export const EntityLevelTaskListName = {
  ORDER_LEVEL_TASK_LIST: 'order_level_task_list',
  LINE_ITEM_LEVEL_TASK_LIST: 'line_item_level_task_list',
  MAIN_TASK_LIST: 'main_task_list',
};

export const EntityLevelTaskBoardName = {
  ORDER_LEVEL_TASK_BOARD: 'order_level_task_board',
  LINE_ITEM_LEVEL_TASK_BOARD: 'line_item_level_task_board',
  MAIN_TASK_BOARD: 'main_task_board',
};

export const TaskEvent = {
  UPDATE_LIST: 'update-list',
  ON_DELETE: 'on-delete',
  ON_COPY: 'on-copy',
  DRAG_START: 'drag-start',
  DRAG_END: 'drag-end',
  INPUT: 'input',
};

export const TaskFields = {
  ID: 'id',
  NAME: 'name',
  DUE_DATE: 'due_date',
  STATUS: 'status',
  STATUS_ID: 'status_id',
  COPY: 'copy',
  TASK: 'task-',
  CLIENTS: 'clients',
  CREATED_AT: '-created_at',
  OPEN: 'Open',
  FIRST: 'first',
  BUTTON: '+ Button',
  ADD_TASK_BUTTON: 'Add Task Button',
  TASK_NAME: 'Task Name',
};

export const ClassNames = {
  IS_TOP_RIGHT: 'is-top-right',
  SMOOTH: 'smooth',
  TR: 'tr',
  IS_SELECTED: 'is-selected',
  TABLE_CONTAINER: '.table-container',
  IS_OVERFLOW_HIDDEN: 'is-overflow-hidden',
  COLUMNS: 'columns',
  GHOST: 'ghost',
  GHOST_CARD: 'ghost-card',
  DRAG_CLASS: 'drag-class',
  OFFSET_HEIGHT: '--offset-height',
  RESIZE: 'resize',
  HANDLE: '.handle',
};

export const TaskFilterFields = {
  SELECT_PLACEHOLDER: 'Select',
  THIS_WEEK: 'this_week',
  DAY: 'day',
  WEEK: 'week',
  TODAY: 'today',
  ASSOCIATION: 'association',
  ASSOCIATED_TO: 'Associated To',
  CLIENT: 'Client',
  CLIENT_GROUP_TITLE: 'Client Group',
  CLIENT_GROUP_FIELD: 'client_group',
  NONE: 'None',
  LINKED_ITEMS: 'linked_items',
  LINKED_ITEMS_TITLE: 'Linked Items',
  DUE_DATE_ASSOCIATION: 'due_date_association',
  OVERDUE_FIELD: 'overdue',
  OVER_DUE_TITLE: 'All Overdue',
  DUE_ON_FIELD: 'due_on',
  DUE_ON_TITLE: 'Due On',
  COMPLETED_ON_FIELD: 'completed_on',
  COMPLETED_ON_TITLE: 'Completed On',
  CREATED_BY: 'created_by',
  DISPLAY_NAME: 'display_name',
  HIGH: 'High',
  LOW: 'Low',
  MEDIUM: 'Medium',
  TAG: 'Tag',
  TAG_ID: 'tag_id',
  CLIENT_ID: 'client_id',
  CLIENT_GROUP_ID: 'client_group_id',
  DUE_DATE_TITLE: 'Due Date',
  PRIORITY: 'Priority',
  ASSIGNEE: 'Assignee',
  CREATED_BY_TITLE: 'Created By',
  QUEUE: 'Queue',
};

export const CLASSIC_MY_TASKS_ROUTE = '/client/iotool/dist/#/items/myTasks';

export const TaskStatuses = {
  COMPLETED: 'Completed',
};
